/** Displays / edits the participants of a GetOffersRequest */

import React from "react";
import { Map } from "immutable";
import { countByAgeGroup } from "./participants-utils";
import classnames from "classnames";

/** UI control to display / edit the particpants */
const Participants = ({ participants = Map(), addParticipant, remParticipant }) => (
  <div className="participants pull-right">
    <ParticipantCounts counts={countByAgeGroup(participants.get("participant"))} addParticipant={addParticipant} remParticipant={remParticipant} />
  </div>
);
/** Displays the current participant counts, and can act as a toggle
 * to show e.g. an editing pop-up window. */
const ParticipantCounts = ({ counts = Map(), addParticipant, remParticipant }) => (
  <div className="participant-counts">
    <AgeGroupCount type="Infant" count={counts.get("infant", 0)} onAdd={addParticipant("INFANT")} onRem={remParticipant("INFANT")} />
    <AgeGroupCount type="Child" count={counts.get("child", 0)} onAdd={addParticipant("CHILD")} onRem={remParticipant("CHILD")} />
    <AgeGroupCount type="Adult" count={counts.get("adult", 0)} onAdd={addParticipant("ADULT")} onRem={remParticipant("ADULT")} />
  </div>
);

const AgeGroupCount = ({ count, type, onAdd, onRem }) => (
  <span className={classnames({ "age-group": true, [type]: type, empty: count < 1 })}>
    {onRem != null && count > (type === "Adult" ? 1 : 0) && <i className="del-btn" onClick={onRem} />}
    <span className="age-group">
      <strong>{count}</strong> {plural(count, type)}
    </span>
    {onAdd != null && <i className="plus-btn" onClick={onAdd} />}
  </span>
);

/* Pluralise an age-group noun */
const plural = (count, noun) => (noun === "Child" && count !== 1 ? "Children" : count !== 1 ? `${noun}s` : noun);

export default Participants;



// WEBPACK FOOTER //
// ./src/ndc/request/Participants.js